
import { audioRecorderWorklet } from "./worklets";

export const registerAudioWorklets = async (context: AudioContext) => {
  const blob = new Blob([audioRecorderWorklet], { type: "application/javascript" });
  const workletUrl = URL.createObjectURL(blob);
  await context.audioWorklet.addModule(workletUrl);
};
